import * as React from 'react';
import { Redirect, Route, Switch } from 'react-router';
import { Link } from 'react-router-dom';
import { SuperAdminLogin } from './Login/SuperAdminLogin';
import { SuperAdminDashboard } from './Dashboard/SuperAdminDashboard';
import { SuperAdminSchools } from './Schools/SuperAdminSchools';
import { SuperAdminSchoolForm } from './Schools/SuperAdminSchoolForm';
import { SuperAdminSchool } from './School/SuperAdminSchool';
import { SuperAdminSports } from './Sports/SuperAdminSports';
import { SuperAdminSportForm } from './Sports/SuperAdminSportForm';
import { SuperAdminUsers } from './Users/SuperAdminUsers';
import { SuperAdminUserForm } from './Users/SuperAdminUserForm';
import { SuperAdminUser } from './User/SuperAdminUser';
import { SuperAdminPostcodes } from './Postcodes/SuperAdminPostcodes';
import { SuperAdminPostcodeForm } from './Postcodes/SuperAdminPostcodeForm';
import { SuperAdminApps } from './Apps/SuperAdminApps';
import { SuperAdminAppForm } from './Apps/SuperAdminAppForm';
import { SuperAdminPermissionRequests } from './PermissionRequests/SuperAdminPermissionRequests';
import { SuperAdminPermissionRequest } from './PermissionRequests/SuperAdminPermissionRequest';
import { SuperAdminUserActivity } from './UserActivity/SuperAdminUserActivity';
import { SuperAdminTools } from './Tools/SuperAdminTools';
import { isSuperAdminLoggedIn } from 'Src/helpers/session/superadminSession';
import { logoutSuperAdmin } from 'Src/helpers/service/superadmin/auth';

function SuperAdminProtectedRoute(props: any) {
  const { component: Component, ...rest } = props;

  return (
    <Route
      {...rest}
      render={routeProps =>
        isSuperAdminLoggedIn() ? <Component {...routeProps} /> : <Redirect to={{ pathname: '/login' }} />
      }
    />
  );
}

function SuperAdminLayout(props: any) {
  const onLogoutClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    logoutSuperAdmin();
    props.history.push('/login');
  };

  return (
    <div>
      <nav className="navbar navbar-expand navbar-light bg-light border-bottom">
        <Link className="navbar-brand" to="/">
          Squad In Touch Superadmin
        </Link>
        <div className="navbar-nav mr-auto">
          <Link className="nav-item nav-link" to="/schools">
            Schools
          </Link>
          <Link className="nav-item nav-link" to="/sports">
            Sports
          </Link>
          <Link className="nav-item nav-link" to="/postcodes">
            Postcodes
          </Link>
          <Link className="nav-item nav-link" to="/apps">
            Applications
          </Link>
          <Link className="nav-item nav-link" to="/users">
            Users
          </Link>
          <Link className="nav-item nav-link" to="/permission-requests">
            Permission requests
          </Link>
          <Link className="nav-item nav-link" to="/user-activity">
            User activity
          </Link>
          <Link className="nav-item nav-link" to="/tools">
            Tools
          </Link>
        </div>
        <a href="/login" onClick={onLogoutClick}>
          Logout
        </a>
      </nav>

      <Switch>
        <Route exact path="/" component={SuperAdminDashboard} />
        <Route exact path="/schools" component={SuperAdminSchools} />
        <Route exact path="/schools/add" component={SuperAdminSchoolForm} />
        <Route exact path="/schools/:schoolId" component={SuperAdminSchool} />
        <Route exact path="/sports" component={SuperAdminSports} />
        <Route exact path="/sports/add" component={SuperAdminSportForm} />
        <Route exact path="/sports/:sportId/edit" component={SuperAdminSportForm} />
        <Route exact path="/postcodes" component={SuperAdminPostcodes} />
        <Route exact path="/postcodes/add" component={SuperAdminPostcodeForm} />
        <Route exact path="/postcodes/:postcodeId/edit" component={SuperAdminPostcodeForm} />
        <Route exact path="/apps" component={SuperAdminApps} />
        <Route exact path="/apps" component={SuperAdminApps} />
        <Route exact path="/apps/add" component={SuperAdminAppForm} />
        <Route exact path="/apps/:appId/edit" component={SuperAdminAppForm} />
        <Route exact path="/users" component={SuperAdminUsers} />
        <Route exact path="/users/new" component={SuperAdminUserForm} />
        <Route exact path="/users/:userId" component={SuperAdminUser} />
        <Route exact path="/permission-requests" component={SuperAdminPermissionRequests} />
        <Route exact path="/permission-requests/:requestId" component={SuperAdminPermissionRequest} />
        <Route exact path="/user-activity" component={SuperAdminUserActivity} />
        <Route path="/tools" component={SuperAdminTools} />
        <Redirect to="/" />
      </Switch>
    </div>
  );
}

export function SuperAdminApp() {
  return (
    <Switch>
      <Route exact path="/login" component={SuperAdminLogin} />
      <SuperAdminProtectedRoute path="/" component={SuperAdminLayout} />
    </Switch>
  );
}
